import { InjectableClass } from '@fino/lib-injection';
import { Features } from '../../config/feature.constants';

import template from './appHeader.html';

class AppHeaderController extends InjectableClass {
  constructor(appConfig, configService) {
    'ngInject';
    super({ appConfig, configService });
  }

  get config() {
    return this.configService.getConfig();
  }

  get brandLogo() {
    return this.useFinoLogo
      ? 'https://s3.eu-central-1.amazonaws.com/fino-tenant-assets/fino/images/logo.complete.png'
      : this.tenantLogo;
  }

  get useFinoLogo() {
    return (
      this.showFinoLogo ||
      this.configService.isFeatureActive(Features.showFinoLogoInHeader)
    );
  }

  get tenantLogo() {
    return this.config && this.config.logo;
  }
}

export default {
  restrict: 'E',
  bindings: {
    showFinoLogo: '<',
  },
  template,
  controllerAs: 'vm',
  controller: AppHeaderController,
};



// WEBPACK FOOTER //
// ./src/app/common/ui/appHeader/appHeader.component.js